import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nganluong',
  templateUrl: './nganluong.component.html',
  styleUrls: ['./nganluong.component.scss']
})
export class NganluongComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
